/* eslint-disable react/button-has-type */
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { loadingSelector } from '../../reducers/selectors';
import Button from '../Button';
import ProdigySpinner from '../ProdigySpinner/ProdigySpinner';

const LoadingButton = ({ children, type, isDisabled, ...propObject }) => {
  const props = propObject;
  const isLoading = useSelector(state => loadingSelector(state));

  if (isLoading === true) {
    return (
      <Button type={type} disabled={true} {...props}>
        <ProdigySpinner />
      </Button>
    );
  }

  return (
    <Button type={type} disabled={isDisabled} {...props}>
      {children}
    </Button>
  );
};

LoadingButton.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  isDisabled: PropTypes.bool,
  theme: PropTypes.string,
};

LoadingButton.defaultProps = {
  type: 'button',
  isDisabled: false,
  theme: undefined,
};

export default LoadingButton;
